"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _addMinutes = _interopRequireDefault(require("date-fns/addMinutes"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _getTime = _interopRequireDefault(require("date-fns/getTime"));
var _roundToNearestMinutes = _interopRequireDefault(require("date-fns/roundToNearestMinutes"));
var _DEFAULT_BRANCH_TIMING = _interopRequireDefault(require("@lumirental/lumi-web-sdk/dist/constants/date/DEFAULT_BRANCH_TIMING"));
var _getKSADate = _interopRequireDefault(require("@lumirental/lumi-web-sdk/dist/utils/store/getKSADate"));
var _DATE_TIME_PICKER = _interopRequireDefault(require("../../../constants/date/DATE_TIME_PICKER"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Function to check if today should be disabled.
 * Today will be disabled if
 *  If T+LeadTime > branch closing time
 *  If T+LeadTime > closing time for 24hr branch or no branch selection
 * @param {Object} todayTiming
 * @param {number} leadTime in minutes
 * @returns {boolean}
 */
function shouldDisableToday(todayTiming, leadTime) {
  // calculate T+LeadTime from now rounded to nearest 30 mins
  var tPlusLeadTime = (0, _addMinutes["default"])((0, _getKSADate["default"])(new Date()), leadTime);
  var roundedLeadTime = (0, _roundToNearestMinutes["default"])(tPlusLeadTime, {
    nearestTo: _DATE_TIME_PICKER["default"].SLOT_INTERVAL
  });

  // it can be possible that today is off so it will not be inside onDays
  // it can be also possible that branch is not selected so onDays is not available
  var end = todayTiming.end,
    is24hr = todayTiming.is24hr;
  var endTime = is24hr ? _DEFAULT_BRANCH_TIMING["default"].end : end;

  // using today as a fake formatter. we just need the time value
  var formattedToday = (0, _format["default"])((0, _getKSADate["default"])(new Date()), 'MMMM dd, yyy'); // eg. 'April 12, 2021'
  var formattedCloseTime = new Date("".concat(formattedToday, " ").concat(endTime));

  // disable today if T+LeadTime > closing time
  return (0, _getTime["default"])(roundedLeadTime) >= (0, _getTime["default"])(formattedCloseTime);
}
var _default = exports["default"] = shouldDisableToday;